import type { PropsWithChildren } from 'react';

export const Empty = ({ children }: PropsWithChildren) => {
  return <>{children}</>;
};
